import React, { useState } from "react";
import { Box, Tabs, Tab, useTheme } from "@mui/material";
import PropTypes from "prop-types";

import BustopTab from "../BustopTab";
import RouteTab from "../RouteTab";
import AreaTab from "../AreaTab";
import EmiratesTab from "../EmiratesTab";
import DriversTab from "../DriversTab";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      sx
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const RouteManagementTabs = () => {
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            style: { display: "none" },
          }}
          sx={{
            "& .MuiTab-root": {
              color: "text.primary",
              "&.Mui-selected": {
                color: theme.palette.background,
                backgroundColor: "primary.main",
              },
            },
          }}
        >
          <Tab label="Pick-up / Drop-off Point" {...a11yProps(0)} />
          <Tab label="Route" {...a11yProps(1)} />
          <Tab label="Area" {...a11yProps(2)} />
          <Tab label="Emirates" {...a11yProps(3)} />
          <Tab label="Drivers" {...a11yProps(4)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <BustopTab />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <RouteTab />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AreaTab />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <EmiratesTab />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <DriversTab />
      </CustomTabPanel>
    </Box>
  );
};

export default RouteManagementTabs;
